import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';
import dateFormat from 'date-fns/format';
import {
  FETCH_CUSTOMER_FAILURE,
  FETCH_CUSTOMER_RESPONSE,
  FETCH_CUSTOMER_REQUEST,
  Customer,
  CustomerActionTypes,
} from '../types/Customer';


import { RootState } from '../store/configureStore';
import {
  digestMessage,
  getCustomerID,
  getCustomerPostcode,
  setCustomerID,
  setCustomerPostcode,
} from '../helpers/functions';
import { getCustomerDetails } from '../api/CustomerApi';
import history from '../helpers/history';
import c from '../helpers/constants';

export function fetchCustomerRequest(): CustomerActionTypes {
  return {
    type: FETCH_CUSTOMER_REQUEST,
    payload: null,
  };
}

export function fetchCustomerResponse(
  customer: Customer,
): CustomerActionTypes {
  return {
    type: FETCH_CUSTOMER_RESPONSE,
    payload: customer,
  };
}

export function fetchCustomerFailure(): CustomerActionTypes {
  return {
    type: FETCH_CUSTOMER_FAILURE,
    payload: null,
  };
}

export const fetchCustomer = (customerId?: string, postcode?: string):
ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch(fetchCustomerRequest());
    const now = new Date;
    const utcTimestamp = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(),
      now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds());
    const formattedDate = dateFormat(utcTimestamp, 'dd/MM/yy');
    const finalPostcode = postcode || getCustomerPostcode() || '';
    const finalCustomerId = customerId || getCustomerID() || '';
    if (!finalCustomerId || !finalPostcode) {
      history.push(c.APP_ROUTES.LOGIN);
    }
    const customerKey = await digestMessage(`${finalPostcode}${formattedDate}`);
    const asyncResp: any = await getCustomerDetails(finalCustomerId, customerKey);
    if (asyncResp?.return_code === 'OK') {
      await dispatch(fetchCustomerResponse(asyncResp?.dsCustomerDetails?.['op-tt-customer']?.[0]));
      setCustomerPostcode(finalPostcode);
      setCustomerID(finalCustomerId);
    } else {
      await dispatch(fetchCustomerFailure());
    }
  };
